export default __webpack_public_path__ + "static/media/Claims.32fa8f35.svg";